import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  userId: '',
  userName: '',
  firstName: '',
  lastName: '',
  email: '',
  accountId: '',
  enterpriseId: '',
  id: '',
  group: '',
  contacts: [],
  activeNumber: null,
  numbers: []
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
